import { Tab, Tabs, TabsProps } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useBuildings } from "../../../graphql/hooks";
import { Building } from "../../../graphql/models";
import { LoadWrapper } from "../load_wrapper";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  );
}

export type BuildingsTabsProps = {
  TabContentComponent: React.FC<{
    building: Building;
  }>;
} & Omit<TabsProps, "value" | "onChange">;
export function BuildingsTabs(props: BuildingsTabsProps) {
  const { TabContentComponent, ...tabsProps } = props;

  const [selectedTabIndex, setSelectedTabIndex] = useState(0);

  const {
    fetchLiteBuildingsList,
    liteBuildingsList,
    liteBuildingsListLoading,
    liteBuildingsListError,
  } = useBuildings();

  useEffect(() => {
    fetchLiteBuildingsList();
  }, [fetchLiteBuildingsList]);

  return (
    <>
      <LoadWrapper
        loading={liteBuildingsListLoading}
        error={liteBuildingsListError}
      >
        <Tabs
          value={selectedTabIndex}
          onChange={(e, idx) => setSelectedTabIndex(idx)}
          indicatorColor="primary"
          textColor="primary"
          {...tabsProps}
        >
          {liteBuildingsList.map((building, idx) => (
            <Tab tabIndex={idx} label={building.code} />
          ))}
        </Tabs>
      </LoadWrapper>
      {liteBuildingsList.map((building, idx) => (
        <TabPanel value={selectedTabIndex} index={idx}>
          <TabContentComponent building={building} />
        </TabPanel>
      ))}
    </>
  );
}
